import { FC, useMemo } from "react"
import { CellStatus } from "."
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { getCellStatusIconTestId } from "@/utils/cells"
interface CellStatusIconProps {
   isMoving?: boolean
   cellStatus?: CellStatus
   typeface?: IconColor
   humanPresenceInVacant?: boolean
   size?: IconProps["size"]
}

const CellStatusIcon: FC<CellStatusIconProps> = ({
   isMoving,
   cellStatus,
   typeface,
   humanPresenceInVacant,
   size = "24",
}) => {
   const cellIcon: IconProps["name"] | null = useMemo(() => {
      if (cellStatus === CellStatus.MAINTENANCE) {
         return "maintenance" as IconProps["name"]
      }
      if (cellStatus === CellStatus.DISCONNECTED) {
         return "disconnected" as IconProps["name"]
      }
      if (cellStatus === CellStatus.INMATE_TRANSFER) {
         return "moveInmate" as IconProps["name"]
      }
      if (cellStatus === CellStatus.VACANT) {
         if (humanPresenceInVacant) {
            return "humanPresence" as IconProps["name"]
         }
      }
      if (isMoving) {
         return "movement" as IconProps["name"]
      }
      return null
   }, [cellStatus, humanPresenceInVacant, isMoving])

   return (
      cellIcon && (
         <Icon
            className="cell-card__status-icon"
            name={cellIcon}
            color={typeface}
            size={size}
            data-testid={getCellStatusIconTestId(cellIcon)}
         />
      )
   )
}

export default CellStatusIcon
